var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('clickedItem', _vm.item_id)}}},[_c('i',{staticClass:"fas",class:_vm.getItemState,staticStyle:{"width":"1.1rem"}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }